module.exports = __webpack_public_path__ + "img/user-ninja.2c529cd0.svg";